<template>
  <el-row type="flex" :align="'middle'" justify="end" class="navigation__sections">
    <el-col>
      <el-menu menu-trigger="click" mode="horizontal" ref="main-menu" :router="true" :default-active="activeMain"
        @open="handleOpen">
        <nav-desktop-products v-if="isLoggedIn" @closeSubmenu="closeSubmenu('products')"></nav-desktop-products>
        <el-menu-item v-if="supportedFeaturesTraining" index="training" :route="{ name: 'Training' }">
          {{ $t('menuTraining') }}
        </el-menu-item>
        <el-submenu v-if="isLoggedIn && usefulResourceLinks && usefulResourceLinks.length > 0"
          v-clickoutside="handleClickOutsideSubmenu" mode="horizontal" index="resources" ref="resources">
          <template slot="title">{{ $t('menuResources') }}</template>
          <el-menu-item v-for="(item, key) in usefulResourceLinks" :key="key">
            <a :href="item.url" target="_blank">{{ item.title }}</a>
          </el-menu-item>
        </el-submenu>
        <el-menu-item v-if="isLoggedIn && supportedFeaturesOutbox" index="outbox" :route="{ name: 'Outbox' }"
          class="button">
          <span class="el-icon-custom-mail outbox-icon">
            <span class="sr-only sr-only-focusable">{{ $t('menuOutbox') }}</span>
            <span v-show="hasAssets" class="outbox-notification">{{ assetCount }}</span>
          </span>
        </el-menu-item>
        <el-menu-item v-if="isLoggedIn && supportedFeaturesSearch" index="search" class="button search"
          :route="{ name: 'Search' }">
          <span class="el-icon-custom-magnify"><span class="sr-only sr-only-focusable">{{ $t('menuSearch')
          }}</span></span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
import authentication from '@/authentication';
import clickoutside from '@/directives/clickoutside';
import nav from '@/components/navigation';
import outbox from '@/components/outbox';
import products from '@/components/products';
import user from '@/components/user';
import offline from '@/offline';
import mixins from '@/mixins';
import NavDesktopProducts from './NavDesktopProducts.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'NavDesktop',
  directives: {
    clickoutside,
  },
  mixins: [
    mixins.supportedFeatures
  ],
  props: {
    desktopMenuActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activeMain: '',
      activeUtility: ''
    };
  },
  computed: {
    ...mapState(authentication.store.namespace, [
      'isLoggedIn'
    ]),
    ...mapState(user.store.namespace, [
      'currentUser'
    ]),
    ...mapState(offline.store.namespace, [
      'isOnline'
    ]),
    ...mapState(products.store.namespace, [
      'categories'
    ]),
    ...mapGetters(user.store.namespace, [
      'region'
    ]),
    ...mapGetters(outbox.store.namespace, [
      'hasAssets',
      'assetCount'
    ]),
    ...mapState(nav.store.namespace, [
      'usefulResourceLinks',
    ])
  },
  methods: {
    closeSubmenu(index) {
      this.$refs["main-menu"].close(index);
    },
    handleClickOutsideSubmenu() {
      if (this.$refs["resources"].$el.classList.contains("is-opened")) {
        this.closeSubmenu('resources');
      }
    },
    handleOpen(submenu) {
      if (submenu === 'products') {
        this.$emit('setDesktopMenuActive', true);
      }
    },
  },
  watch: {
    desktopMenuActive(newActive, oldActive) {
      if (!newActive) {
        this.closeSubmenu('products');
      }
    },
    $route(to) {
      if (!!to.fullPath.match(/^\/products/)) {
        this.activeMain = 'products'
      } else if (!!to.fullPath.match(/^\/training/)) {
        this.activeMain = 'training'
      } else if (!!to.fullPath.match(/^\/resources/)) {
        this.activeMain = 'resources'
      } else {
        this.activeMain = ''
      }
      if (!!to.fullPath.match(/^\/settings/)) {
        this.activeUtility = 'settings'
      } else if (!!to.fullPath.match(/^\/outbox/)) {
        this.activeUtility = 'outbox'
      } else if (!!to.fullPath.match(/^\/search/)) {
        this.activeUtility = 'search'
      } else {
        this.activeUtility = ''
      }
    }
  },
  components: {
    NavDesktopProducts,
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.navigation__sections {
  .el-menu.el-menu--horizontal {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-end;

    &>.el-menu-item,
    &:deep(.el-submenu__title) {
      height: $--menu-height-desktop-md;
      line-height: $--menu-height-desktop-md;
      padding-left: 0.95rem;
      padding-right: 0.95rem;


      @include res(lg) {
        height: $--menu-height-desktop;
        line-height: $--menu-height-desktop;
        padding-left: 2rem;
        padding-right: 2rem;
      }
    }

    &>.el-menu-item {
      &.button {
        padding-left: 1rem;
        padding-right: 1rem;

        @include res(lg) {
          padding-left: 1.5rem;
          padding-right: 1.5rem;
        }

        &.search {
          color: $--color-white;
          background-color: $--color-primary;
        }

        &>span {
          margin-right: 0;
        }
      }
    }
  }
}

.outbox-icon {
  position: relative;

  .outbox-notification {
    position: absolute;
    right: -18px;
    bottom: -10px;
    border-radius: 50%;
    width: 1.25rem;
    height: 1.25rem;
    padding: .2rem;
    background-color: $--color-primary;
    color: $--color-white;
  }
}
</style>
